import React, { useState } from 'react';

import { useParams } from 'react-router-dom';

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import MfaDialog from 'views/login/MfaDialog.jsx';

import LoadingPanel from 'views/widgets/LoadingPanel.jsx';
import Cookies from "js-cookie"

import useInterval from '../../hooks/useInterval.js';

import './styles.css';

export default function LoginCustomView(props) {
	
	const { authenticatedCallback, loadPreferences } = props;
	
	const { orgCode, autoStart, idpInit } = useParams();

	const initialState = {
		organizationLookupComplete: false,
		masked: false,
		error: false,
		customRequestId: null,
		forceIdpAuth: false,
		organization: null,
		customLoginWindow: null,
		waitingForResponse: false,
		timeSpentWaiting: 0,
		preferences: null
	};
	const [state, setState] = useState(initialState);	
	
	const closeDialog = () => {
		setState({ ...state, mfaDialog: false });
	}
	
	const mfaAuthorizeDeviceFailed = (message) => {
		setState({ ...state, masked: false, error: message });
	}

	// handle submission of the login form
	const handleSubmit = (e) => {
		e.preventDefault();
		openLoginWindow();
	};
	
	useInterval(() => {
		checkForResponse();
    }, state.waitingForResponse ? 1000 : null);
    
    const loadPreferencesFromState = () => {
		loadPreferences(state.preferences);
		setState({...state, preferences: null});
	}
	
	const validateCustomRequestId = (customAuthRequestId) => {
		let data = new URLSearchParams();
		data.append('username', "custom-auth-request");
		data.append('password', customAuthRequestId);

		Cookies.remove("custom_auth_request_id");
		setState({ ...state, masked: true });
		fetch(API_URL + "/perform_login", { 
			method: 'POST', 
			body: data,
			credentials: 'include'
		}).then(response => response.json()
			.then(data => ({ status: response.status, body: data }))
		).then((result) => {
				if (result.status == 200 && !result.body.pendingMfa) {
					loadPreferences(result.body);
					authenticatedCallback();
					setState({ ...state, masked: false, mfaDialog: false });
				} else if (result.status == 200 && result.body.pendingMfa) {
					setState({...state, mfaDialog: true, preferences: result.body, masked: false});

				} else if (result.status == 406) {
					throw new Error("Your user has no assigned roles.  Please contact your organization administrator.");

				} else {
					throw new Error("Authentication request not approved. Please try again or contact your Constituo administrator.");
				}
			}).catch((error) => {
				setState({ ...state, masked: false, error: error.message });
			});
	}
	
	/* SSO Functions */
	
	const checkForResponse = () => {
		let customAuthRequestId = Cookies.get("custom_auth_request_id");
		let customAuthRequestException = Cookies.get("custom_auth_request_exception");
		let customAuthRequestForceAuthCookie = Cookies.get("custom_auth_request_force_auth");
		let customAuthRequestForceAuth = customAuthRequestForceAuthCookie !=null ? true : false;
		let timeSpentWaiting = state.timeSpentWaiting;  		
  		if(customAuthRequestId!=null){
			setState({ ...state, waitingForResponse: false});
			validateCustomRequestId(customAuthRequestId);
		}else if(customAuthRequestForceAuth){
			Cookies.remove("custom_auth_request_exception");
			Cookies.remove("custom_auth_request_force_auth");
			setState({ ...state, waitingForResponse: false});
			openLoginWindow(customAuthRequestForceAuth!=null ? true : false);
		}else if(customAuthRequestException!=null){
			Cookies.remove("custom_auth_request_exception");
			Cookies.remove("custom_auth_request_force_auth");
          	setState({ ...state, waitingForResponse: false, masked: false, error: customAuthRequestException});
		}	
		else{
			timeSpentWaiting = timeSpentWaiting + 1000;
			setState({...state, timeSpentWaiting: timeSpentWaiting});
		}
	}
	
	const lookupOrganization = () => {
		fetch(API_URL + "/public/organization/" + orgCode, {
			method: 'GET'
		}).then(function(response) {
			if (response.ok) { return response.json(); }
			else { throw new Error(response.status); }
		}).then(function(org) {
			state.organization = org;
			if(org.auth.customAuthEnabled){
				if(!idpInit){
					setState({...state, organization: org, organizationLookupComplete: true });
					if(autoStart) openLoginWindow();	
				}else{
					checkForResponse();
				}
			}else{
				redirectToLogin();
			}
		}).catch(function(err) {
			let errMsg = (err.message === '403') ? ("Organization not found") : ("Failed to fetch organization.  If this problem persists, please contact Support.");
          	setState({ ...state, masked: false, error: errMsg, organizationLookupComplete: true });
		});
	}
	
	const redirectToLogin = () => {
		window.location = "../"; //redirect to primary login
	}
	
	const openLoginWindow = (forceAuth) => {
		let redirectUrl = state.organization.auth.customLoginAppUrl + "/?i=" + orgCode;
		if(forceAuth === true)
			redirectUrl += "&forceAuth=true";
		let customLoginWindow = window.open(redirectUrl);
		setState({...state, timeSpentWaiting: 0, waitingForResponse: true, masked: true, customLoginWindow: customLoginWindow});
	}
	
	const closeErrorDialog = () => {
		setState({ ...state, dialog: null });
	}
	
	if(state.organization==null && orgCode!=null && !state.organizationLookupComplete){
		Cookies.remove("custom_auth_request_id");
		lookupOrganization();
	}
	return (
		<div className='login-container'>
			<div id='content-container'>
				<div id='content-container-top-bar'>
					<div id='login-logo'><span id="logo-wheel" className="fa fa-cs-logo"/><span id="login-company-name" className="ubuntu">constituo</span><span id='name-registered-mark' className='fa fa-registered'></span></div>
				</div>
				<div id='content-logo-container'>
					<div id="slogan">Smarter and Faster Campus Processes</div>
					<div id="subslogan">Automate your campus in a new, simplified content services platform</div>
				</div>
				<div id='content-latest-news-updates'>
						<div id='latest-news-separator'></div>
						<div id="latest-news-header">Latest news <span>& updates</span></div>
						<div id="latest-news-blurb">Constituo Software kicks off the Early Adopter Program for Constituo Content. For more information, contact the product group at <a href="mailto:productmanagement@constituo.com">productmanagement@constituo.com</a></div>
				</div>
				
			</div>
			<div id='form-container'>
				<div id="login-form-upper-left-cloud">
				</div>
				<div id='inner-form-container'>
					<div id='login-application-logo'><span id="application-logo-wheel" className="fa fa-cs-logo"/><span id="login-application-name" className="ubuntu">content</span><span id='application-registered-mark' className='fa fa-trademark'></span></div>
					<form id='login-form' onSubmit={handleSubmit} aria-label="Login Form">
						{state.organization!=null && <div id='login-organization'>{state.organization.name}</div>}
						{state.waitingForResponse && <div id='time-waiting'>{state.timeSpentWaiting}</div>}
						<button aria-label="Sign In" tabIndex="3" type="submit" id="login-btn">Sign In</button>
						<div id="prosecution">WARNING: Unauthorized access to this system is forbidden and will be prosecuted by law. By accessing this system, you agree that your actions may be monitored if unauthorized usage is suspected.</div>
					</form>
					<div id="copyright"><span className="fa fa-copyright"></span> <span className="copyright-year">{new Date().getFullYear()}</span> Constituo Software LLC. All rights reserved.</div>
				</div>
				<div id="login-form-lower-right-cloud">
				</div>
			</div>

			{state.masked && <LoadingPanel />}

			{state.error && (
				<Dialog title={"Authentication Failed"} onClose={() => { setState({ ...state, error: false }); }}>
					<p
						style={{
							margin: "25px",
							textAlign: "center",
						}}
					>
						{state.error}
					</p>
					<DialogActionsBar>
						<button
							className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
							onClick={() => { setState({ ...state, error: false }); }}
						>
							Close
						</button>
					</DialogActionsBar>
				</Dialog>
			)}
			
			{state.dialog && (
				<Dialog title={state.dialog.title} onClose={closeErrorDialog}>
					<p
						style={{
							margin: "25px",
							textAlign: "center",
						}}
					>
						{state.dialog.body}
					</p>
					<DialogActionsBar>
						<button
							className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
							onClick={closeErrorDialog}
						>
							Close
						</button>
					</DialogActionsBar>
				</Dialog>
			)}
			
			{state.mfaDialog && (
				<MfaDialog 
					authenticatedCallback={authenticatedCallback}
					cancelCallback={closeDialog}
					loadPreferencesFromStateCallback={loadPreferencesFromState}
					mfaAuthorizeDeviceFailedCallback={mfaAuthorizeDeviceFailed}
					username={state.preferences.user.username}
				/>
			)}
		</div>
	);
}